<section class="vo-card" aria-labelledby="step4-title">
  <header class="vo-card__head">
    <h2 class="vo-card__title" id="step4-title">Fast geschafft!</h2>
    <p class="vo-card__sub">Wie die Unternehmen Sie erreichen — und wann es losgehen soll.</p>
  </header>

  <form class="vo-grid" [formGroup]="draftInquiryForm" novalidate>
    <div class="vo-field">
      <label class="vo-label" for="first_name">Vorname</label>
      <input id="first_name" type="text" class="vo-input" formControlName="first_name" placeholder="Anna"
             autocomplete="given-name" [class.is-invalid]="hasError('first_name')">
      <p class="vo-error" *ngIf="hasError('first_name')">
        <app-icon name="circle-alert" [size]="14"/>
        Dieses Feld ist erforderlich
      </p>
    </div>

    <div class="vo-field">
      <label class="vo-label" for="last_name">Nachname</label>
      <input id="last_name" type="text" class="vo-input" formControlName="last_name" placeholder="Müller"
             autocomplete="family-name" [class.is-invalid]="hasError('last_name')">
      <p class="vo-error" *ngIf="hasError('last_name')">
        <app-icon name="circle-alert" [size]="14"/>
        Dieses Feld ist erforderlich
      </p>
    </div>

    <div class="vo-field">
      <label class="vo-label" for="phone">Telefonnummer</label>
      <input id="phone" type="tel" class="vo-input" formControlName="phone" placeholder="z.B. 079 123 45 67"
             autocomplete="tel" [class.is-invalid]="hasError('phone')">
      <p class="vo-error" *ngIf="hasError('phone', 'required')">
        <app-icon name="circle-alert" [size]="14"/>
        Telefonnummer ist erforderlich
      </p>
      <p class="vo-error" *ngIf="hasError('phone', 'pattern')">
        <app-icon name="circle-alert" [size]="14"/>
        Bitte geben Sie eine gültige Telefonnummer ein (z.B. +41 79 123 45 67)
      </p>
    </div>

    <div class="vo-field">
      <label class="vo-label" for="email">E-Mail-Adresse</label>
      <input id="email" type="email" class="vo-input" formControlName="email" placeholder="ihre.email@beispiel.ch"
             autocomplete="email" [class.is-invalid]="hasError('email')">
      <p class="vo-error" *ngIf="hasError('email')">
        <app-icon name="circle-alert" [size]="14"/>
        Bitte geben Sie eine gültige E-Mail-Adresse ein
      </p>
    </div>

    <h3 class="vo-section-head">Wunschtermin</h3>

    <div class="vo-field">
      <label class="vo-label" for="date">{{ isCleaningOnly ? 'Reinigungsdatum' : 'Umzugsdatum' }}</label>
      <input id="date" type="date" class="vo-input" formControlName="date" [min]="minDate"
             [class.is-invalid]="hasError('date')">
      <p class="vo-error" *ngIf="hasError('date')">
        <app-icon name="circle-alert" [size]="14"/>
        Bitte wählen Sie ein Datum in der Zukunft
      </p>
    </div>

    <div class="vo-field">
      <label class="vo-label" for="handover_date">
        {{ isCleaningOnly ? 'Wohnungsabgabe' : 'Übergabetermin' }}
        <span class="vo-label__optional">(optional)</span>
      </label>
      <input id="handover_date" type="date" class="vo-input" formControlName="handover_date" [min]="minDate"
             [class.is-invalid]="hasError('handover_date')">
      <p class="vo-error" *ngIf="hasError('handover_date')">
        <app-icon name="circle-alert" [size]="14"/>
        {{ isCleaningOnly ? 'Sollte nach dem Reinigungsdatum liegen' : 'Sollte nach dem Umzugsdatum liegen' }}
      </p>
    </div>

    <div class="vo-field vo-field--full">
      <label class="vo-option vo-option--check" [class.is-selected]="draftInquiryForm.controls.is_date_flexible.value">
        <input type="checkbox" class="vo-sr-only" formControlName="is_date_flexible">
        <span class="vo-box" aria-hidden="true"><app-icon name="check" [size]="13" [strokeWidth]="3.5"/></span>
        <span class="vo-option__body">
          <span class="vo-option__title">Dieses Datum ist flexibel</span>
          <span class="vo-option__desc">Flexible Termine senken den Preis oft um 10–15%.</span>
        </span>
      </label>
    </div>

    <div class="vo-field vo-field--full">
      <span class="vo-label" id="step4-availability">
        Beste Erreichbarkeit <span class="vo-label__optional">(optional)</span>
      </span>
      <div class="vo-chips" role="group" aria-labelledby="step4-availability">
        <button *ngFor="let option of availabilityOptions" type="button" class="vo-chip"
                [class.is-selected]="isAvailabilitySelected(option.value)"
                [attr.aria-pressed]="isAvailabilitySelected(option.value)"
                (click)="toggleAvailability(option.value)">
          <app-icon [name]="option.lucideIcon"/>
          {{ option.label }}
        </button>
      </div>
    </div>

    <div class="vo-field vo-field--full">
      <div class="vo-note">
        <app-icon name="mail"/>
        <p>
          Nach dem Absenden erhalten Sie eine E-Mail mit Bestätigungslink. Erst nach der Bestätigung wird Ihre
          Anfrage an die Unternehmen weitergeleitet.
        </p>
      </div>
    </div>

    <div class="vo-field vo-field--full">
      <label class="vo-option vo-option--check"
             [class.is-selected]="draftInquiryForm.controls.accept_terms.value"
             [class.is-invalid]="hasError('accept_terms')">
        <input type="checkbox" class="vo-sr-only" formControlName="accept_terms">
        <span class="vo-box" aria-hidden="true"><app-icon name="check" [size]="13" [strokeWidth]="3.5"/></span>
        <span class="vo-option__body">
          <span class="vo-option__title">Ich akzeptiere die Nutzungsbedingungen</span>
          <span class="vo-option__desc">
            Ich bestätige, sie gelesen zu haben, und habe die Datenschutzerklärung zur Kenntnis genommen.
          </span>
        </span>
      </label>
      <p class="vo-error" *ngIf="hasError('accept_terms')">
        <app-icon name="circle-alert" [size]="14"/>
        Bitte akzeptieren Sie die Nutzungsbedingungen und die Datenschutzerklärung
      </p>
    </div>

    <div class="vo-field vo-field--full">
      <label class="vo-option vo-option--check" [class.is-selected]="draftInquiryForm.controls.newsletter.value">
        <input type="checkbox" class="vo-sr-only" formControlName="newsletter">
        <span class="vo-box" aria-hidden="true"><app-icon name="check" [size]="13" [strokeWidth]="3.5"/></span>
        <span class="vo-option__body">
          <span class="vo-option__title">Newsletter erhalten</span>
          <span class="vo-option__desc">Tipps zu Umzug und Reinigung, maximal monatlich.</span>
        </span>
      </label>
    </div>
  </form>
</section>

<app-inquiry-step-nav [busy]="isSubmitting" (back)="goBack()" (next)="onSubmit()"/>
